import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Chrome rapporterer dette når ResizeObserver (MUI DataGrid, dialoger m.m.)
// endrer layout i samme frame. Ufarlig, men webpack-dev-server viser rød overlay.
window.addEventListener(
  'error',
  (event) => {
    if (
      event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      event.message === 'ResizeObserver loop limit exceeded'
    ) {
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);